// Constants
export { COMPANY_EMAIL } from './COMPANY_EMAIL';
export { COMPANY_PHONE } from './COMPANY_PHONE';
export { COMPANY_PHONE_UNFORMATTED } from './COMPANY_PHONE_UNFORMATTED';
export { MESSAGE } from './MESSAGE';
export { SOCIAL_LINKS } from './SOCIAL_LINKS';
export { CONTACT_METHODS } from './CONTACT_METHODS';

// Interfaces
export type { SocialLink } from './SocialLink'; 